/* === LUKO GYM FREE GIFT LOGIC === */
async function lukoSyncFreeGift() {
  const giftVariantId = window.LUKO_FREE_GIFT?.variantId || 0;
  const threshold = window.LUKO_FREE_GIFT?.threshold || 0;
  if (!giftVariantId || !threshold) return;

  try {
    // 1. Warenkorb holen
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    // 2. Subtotal ohne Gift berechnen
    let subtotalCents = 0;
    let giftLineItem = null;

    cart.items.forEach(item => {
      if (item.variant_id === giftVariantId) {
        giftLineItem = item;
        return;
      }
      subtotalCents += item.original_line_price;
    });

    const subtotal = subtotalCents / 100.0;
    const hasGift = !!giftLineItem;

    // 3. Gift hinzufügen?
    if (subtotal >= threshold && !hasGift) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: giftVariantId,
            quantity: 1,
            properties: {
              "Gift": "Gratis ab " + threshold + "€"
            }
          }]
        })
      });
      console.log("✅ Gratisprodukt hinzugefügt.");
    }

    // 4. Gift entfernen?
    if (subtotal < threshold && hasGift) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftLineItem.key,
          quantity: 0
        })
      });
      console.log("❌ Gratisprodukt entfernt (Warenwert unter Schwelle).");
    }
  } catch (err) {
    console.error("LUKO Free Gift Error:", err);
  }
}

/* === Event-Listener einhängen === */
// Läuft beim Laden der Seite
document.addEventListener("DOMContentLoaded", () => {
  lukoSyncFreeGift();
});

// Läuft jedes Mal, wenn der Warenkorb sich ändert (wenn dein Theme das Event feuert)
document.addEventListener("cart:updated", () => {
  lukoSyncFreeGift();
});
